<template>
  <s-drawer
    :title="$i18n('Support Panel')"
    v-model="show"
    :append-to-body="true"
    style="position: absolute"
    class="switch-panel"
  >
    <s-tabs v-model="activeTab" type="line" @tab-click="handleTabClick">
      <s-tabs-pane
        name="Configuration"
        :label="this.$i18n('Configuration Panel')"
      >
        <ConfPanel />
      </s-tabs-pane>
      <!-- <s-tabs-pane name="Permission" :label="this.$i18n('Permission Panel')">
        <PermissionPanel />
      </s-tabs-pane> -->
    </s-tabs>
  </s-drawer>
</template>
<script lang="ts">
import { reportEvent } from '@/utils/qms';
import { Component, ModelSync, Vue } from 'vue-property-decorator';
import ConfPanel from './conf-panel.vue';
import PermissionPanel from './permission-panel.vue';
@Component({
  components: {
    ConfPanel,
    PermissionPanel,
  },
})
export default class SwitchPanel extends Vue {
  @ModelSync('value', 'change', { type: Boolean }) show!: boolean;
  activeTab = 'Configuration';

  handleTabClick() {
    const key =
      this.activeTab === 'Configuration'
        ? 'click_support_panel_configuration_tab'
        : 'click_support_panel_permission_tab';
    reportEvent(key);
  }
}
</script>

<style lang="scss" scoped>
.switch-panel {
  ::v-deep .ssc-drawer {
    width: 700px !important;

    .ssc-drawer-header {
      border-bottom: none;
    }

    .ssc-drawer-body {
      padding: 0 16px;
    }
  }
}
</style>
